module.exports = __webpack_public_path__ + "media/images/bg-pattern-139dd1361e9241d61efbea7bb0c2c08c.png";